














































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { MidiCcToNote } from "../bl/midiCcToNote";
import { midiThereminSliders } from '../bl//midiSlider'

import W3InputNumber from '@/components/W3InputNumber.vue'; // @ is an alias to /src
import W3Checkbox from '@/components/W3Checkbox.vue'; // @ is an alias to /src

const noInterfaceSelectedId = 0;
const noInterfaceSelectedName = "none";
const noInterfaceSelected = {
  id: noInterfaceSelectedId,
  name: noInterfaceSelectedName
};




@Component({
  components: {
    W3InputNumber,
    W3Checkbox
  },
})
export default class HelloWorld extends Vue {

  
  msgConnected: string = "";
  msgRouted:string = "";
  
  jsonSequence:string = JSON.stringify([ ["C4","E4"],0,"D4","E4"])
  seqModIsActive = false;
  isVcvMode = false;
  isRepeatSequence = true
  isSequenceCordsAsCustomScale = false;
  semitonsBetweenCustomScaleNotes = "3"
  sequenceModeMaxBendRange = "12"
  volumeInputCC = "21"
  pitchInputCC = "20"

  ccpitchIsActive = false;
  ccpitchIsPlayPitchAndCC = false;
  ccpitchSendToCcChannel = "1"
  ccpitchNegativeSendToMinVal = "1"
  ccpitchNegativeSendToMaxVal = "127"
  ccpitchPositiveSendToMinVal = "1"
  ccpitchPositiveSendToMaxVal = "127"

  playingNotes: any[] = []

  midiOutputs: { id: number; name: string }[] = [noInterfaceSelected];
  midiOutput: number = noInterfaceSelectedId;

  midiInputs: { id: number; name: string }[] = [noInterfaceSelected];
  midiInput: number = noInterfaceSelectedId;

  receiveFromChannel = "0";
  sendToChannel = "0"

  pitchBendPosition = "0";

  midiSliderPosition = "64";

  thereminVolumePosition = "0";
  thereminPitchPosition = "64";

  volumeTriggerPlayAbouve = "5"
  volumeTriggerStopBelow = "5"
  volumeSendToResetVal = "50"
  volumeIgnoreVolumeChangeInMillisecondsAfterNewNote = "80"
  volumeSendToCcChannel = "7"
  volumeStartCcPosition = "1"
  volumeEndCcPosition = "127"
  volumeSendToMinVal = "1"
  volumeSendToMaxVal = "127"
  volumeIsMuteAbouveEndCcPosition = false

  pitchSemitonPerOctaveBend = "12"
  pitchSemitonsAutoTrigerNote = "12"
  pitchIgnorePitchbendChangeInMillisecondsAfterNewNote = "0"
  pitchMidiStartNote = "50"
  pitchMidiEndNote = "86"
  pitchStartCcPosition = "1"
  pitchEndCcPosition = "127"



  doStartVolumeRouting(){
    midiThereminSliders.outputId = this.midiOutput;
    midiThereminSliders.midiVolumeSlider.receiveFromDeviceId = this.midiInput;
    midiThereminSliders.midiVolumeSlider.receiveFromCcChannel = Number( this.volumeInputCC );

    midiThereminSliders.receiveFromChannel = Number(this.receiveFromChannel) === 0 ? undefined :Number(this.receiveFromChannel)
    midiThereminSliders.sendToChannel = Number(this.sendToChannel) === 0 ? undefined :Number(this.sendToChannel)

    midiThereminSliders.midiSequence.isActive = this.seqModIsActive;
    midiThereminSliders.midiSequence.index = 0;

    midiThereminSliders.isVcvMode = this.isVcvMode

    midiThereminSliders.midiSequence.repeatSequence = this.isRepeatSequence 
    midiThereminSliders.midiSequence.sequenceCordsAsCustomScale = this.isSequenceCordsAsCustomScale
    midiThereminSliders.midiSequence.semitonsBetweenCustomScaleNotes = Number(this.semitonsBetweenCustomScaleNotes)
    midiThereminSliders.midiSequence.sequence = JSON.parse( this.jsonSequence )
    midiThereminSliders.midiSequence.bendRangeInMemitons = Number( this.sequenceModeMaxBendRange );

    midiThereminSliders.ccpitch.isActive = this.ccpitchIsActive;
    midiThereminSliders.ccpitch.isPlayPitchAndCC = this.ccpitchIsPlayPitchAndCC;
    midiThereminSliders.ccpitch.sendToCcChannel = Number(this.ccpitchSendToCcChannel);
    midiThereminSliders.ccpitch.negativeSendToMinVal = Number(this.ccpitchNegativeSendToMinVal)
    midiThereminSliders.ccpitch.negativeSendToMaxVal = Number(this.ccpitchNegativeSendToMaxVal)
    midiThereminSliders.ccpitch.positiveSendToMinVal = Number(this.ccpitchPositiveSendToMinVal)
    midiThereminSliders.ccpitch.positiveSendToMaxVal = Number(this.ccpitchPositiveSendToMaxVal)

    midiThereminSliders.midiVolumeSlider.triggerPlayAbouve = Number( this.volumeTriggerPlayAbouve)
    midiThereminSliders.midiVolumeSlider.triggerStopBelow = Number( this.volumeTriggerStopBelow)
    midiThereminSliders.midiVolumeSlider.sendToResetVal = Number( this.volumeSendToResetVal)
    midiThereminSliders.midiVolumeSlider.ignoreVolumeChangeInMillisecondsAfterNewNote = Number( this.volumeIgnoreVolumeChangeInMillisecondsAfterNewNote )
    
    midiThereminSliders.midiVolumeSlider.sendToCcChannel = Number( this.volumeSendToCcChannel)

    let volumeStartCcPosition = Number( this.volumeStartCcPosition )
    let volumeEndCcPosition =  Number( this.volumeEndCcPosition )
    if (volumeEndCcPosition < volumeStartCcPosition) {
      midiThereminSliders.midiVolumeSlider.startCcPosition = volumeEndCcPosition 
      midiThereminSliders.midiVolumeSlider.endCcPosition = volumeStartCcPosition
      midiThereminSliders.midiVolumeSlider.reverseCcPosition = true
    } else {
      midiThereminSliders.midiVolumeSlider.startCcPosition = volumeStartCcPosition
      midiThereminSliders.midiVolumeSlider.endCcPosition = volumeEndCcPosition
      midiThereminSliders.midiVolumeSlider.reverseCcPosition = false
    }


    midiThereminSliders.midiVolumeSlider.sendToMinVal = Number( this.volumeSendToMinVal)
    midiThereminSliders.midiVolumeSlider.sendToMaxVal = Number( this.volumeSendToMaxVal )
    midiThereminSliders.midiVolumeSlider.isMuteAbouveEndCcPosition = this.volumeIsMuteAbouveEndCcPosition

    midiThereminSliders.midiPitchSlider.receiveFromDeviceId = this.midiInput;
    midiThereminSliders.midiPitchSlider.receiveFromCcChannel = Number( this.pitchInputCC );

    midiThereminSliders.midiPitchSlider.semitonPerOctaveBend = Number( this.pitchSemitonPerOctaveBend )
    midiThereminSliders.midiPitchSlider.semitonsAutoTrigerNote = Number( this.pitchSemitonsAutoTrigerNote)
    midiThereminSliders.midiPitchSlider.ignorePitchbendChangeInMillisecondsAfterNewNote = Number( this.pitchIgnorePitchbendChangeInMillisecondsAfterNewNote)
    midiThereminSliders.midiPitchSlider.midiStartNote = Number( this.pitchMidiStartNote )
    midiThereminSliders.midiPitchSlider.midiEndNote = Number( this.pitchMidiEndNote )
    
    let pitchStartCcPosition = Number( this.pitchStartCcPosition )
    let pitchEndCcPosition =  Number( this.pitchEndCcPosition )
    if (pitchEndCcPosition < pitchStartCcPosition) {
      midiThereminSliders.midiPitchSlider.startCcPosition = pitchEndCcPosition 
      midiThereminSliders.midiPitchSlider.endCcPosition = pitchStartCcPosition
      midiThereminSliders.midiPitchSlider.reverseCcPosition = true
    } else {
      midiThereminSliders.midiPitchSlider.startCcPosition = pitchStartCcPosition
      midiThereminSliders.midiPitchSlider.endCcPosition = pitchEndCcPosition
      midiThereminSliders.midiPitchSlider.reverseCcPosition = false
    }


    midiThereminSliders.startRouting();
    this.msgRouted = "Routing"
  }

  doStopVolumeRouting(){
    midiThereminSliders.stopRouting();
    this.msgRouted = ""
  }

  doPitchVolumeSend(): void{
   midiThereminSliders.outputId = this.midiOutput;
   midiThereminSliders.setVolume(Number(this.thereminVolumePosition))
   midiThereminSliders.setPitch(Number(this.thereminPitchPosition))
   
  }

  doPlayMidiSliderByBand(): void{
    let pitchBendPosition = midiThereminSliders.midiPitchSlider.getPitchBendPosition(Number(this.midiSliderPosition))
    MidiCcToNote.sendPitchBend(this.midiOutput, pitchBendPosition, undefined)

  }
  
  doPlaySliderByNote(): void{
    midiThereminSliders.midiPitchSlider.setMidiCurrentNotePlayingByPosition(Number(this.midiSliderPosition))
    MidiCcToNote.playNotes(this.midiOutput, midiThereminSliders.midiPitchSlider.midiCurrentNotePlaying, undefined)
    this.playingNotes = MidiCcToNote.playingNotes;
  }

  doStopSliderNote(): void{
    MidiCcToNote.stopNote(this.midiOutput, midiThereminSliders.midiPitchSlider.midiCurrentNotePlaying, undefined)
    MidiCcToNote.sendPitchBend(this.midiOutput, Number(this.pitchBendPosition), undefined)
    this.playingNotes = MidiCcToNote.playingNotes;
  }

  doStartC4(): void {
    MidiCcToNote.playNotes(this.midiOutput, "C4", undefined)
    this.playingNotes = MidiCcToNote.playingNotes;
  }

  doStopC4(): void {
    MidiCcToNote.stopNote(this.midiOutput, "C4", undefined)
    this.playingNotes = MidiCcToNote.playingNotes;
  }

  doPitchBend(){
    MidiCcToNote.sendPitchBend(this.midiOutput, Number(this.pitchBendPosition), undefined)
  }

  doConnect(): void {
    MidiCcToNote
      .connect()
      .then(() => {
        this.msgConnected = "Connected";
        this.midiOutputs = [noInterfaceSelected].concat(
          MidiCcToNote.getMidiOutputs()
        );
        this.midiInputs = [noInterfaceSelected].concat(
          MidiCcToNote.getMidiInputs()
        );
      })
      .catch((e: Error) => {
        this.msgConnected = e.message;
      });
  }
}
